/**
 * Auth State - simplified (token in HttpOnly cookie, user in localStorage)
 *
 * Auth status: BOTH cookie set by backend AND user stored in localStorage
 * （真实 token 在服务端设置的 HttpOnly cookie 里，JS 不可见；
 *  localStorage 只存用户信息用于展示，鉴权状态由每次 API 请求的 cookie 真实校验）
 */

const USER_KEY = 'course-management-web_user'

export interface AuthUser {
  id: number
  email: string
  name: string
}

export function getStoredUser(): AuthUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? (JSON.parse(raw) as AuthUser) : null
  } catch {
    return null
  }
}

export function isAuthenticated(): boolean {
  // Token is in HttpOnly cookie (invisible to JS), so we just check user
  // If user is in localStorage, we assume they're logged in
  // (real check happens via cookie on every API call)
  return !!getStoredUser()
}

export function setAuth(user: AuthUser): void {
  // The real token is in HttpOnly cookie set by backend
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function clearAuth(): void {
  localStorage.removeItem(USER_KEY)
}
